import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axiosInstance from "../../axiosConfig";

function DevLogin() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState("");

  useEffect(() => {
    const code = searchParams.get("code");
    if (!code) {
      setError("No auth code provided.");
      return;
    }

    const exchangeCode = async () => {
      try {
        const response = await axiosInstance.post("/myclub/dev-exchange/", { code });

        // Store tokens in localStorage (same pattern as ClubLogin.js)
        localStorage.setItem("access_token", response.data.access);
        localStorage.setItem("refresh_token", response.data.refresh);
        localStorage.setItem("user_profile", JSON.stringify({
          is_club: true,
          club_id: response.data.club_id,
          club_name: response.data.club_name,
          dev_mode: true,
        }));

        navigate("/myclub/dashboard");
      } catch (err) {
        setError("Invalid or expired code. Please try again from the staff admin.");
      }
    };

    exchangeCode();
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", fontFamily: "sans-serif" }}>
        <div style={{ textAlign: "center" }}>
          <p style={{ color: "#dc3545", fontSize: "18px" }}>{error}</p>
          <p style={{ color: "#666" }}>Go back to the staff admin and click "Dev View Dashboard" again.</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", fontFamily: "sans-serif" }}>
      <div style={{ textAlign: "center" }}>
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-900 mx-auto"></div>
        <p style={{ marginTop: "16px", color: "#666" }}>Loading club dashboard...</p>
      </div>
    </div>
  );
}

export default DevLogin;
